import styled from "styled-components";
import { StyledTitle } from "src/affiliate/components/affiliate-landing/section-two/assets/styles/section-two-main.styled";

export const StyledFrequently = styled(StyledTitle)`
    @media only screen and (max-width: 568px) {
        padding: 0 24px;
    }
`;